import { I18n } from "aws-amplify/utils";


// The function translates a string or database field name into a user friendly label in a given language. 
export function translate(key?: string | null) {
  if (!key) {
    console.warn('Undefined resource provided')
    return ''
  }

  // Transform a field name into a human readable string.
  if (key.indexOf('_') >= 0) {
    key = key.charAt(0).toUpperCase() + key.replaceAll('_', ' ').toLowerCase().slice(1);
  }

  return I18n.get(key).toString();
}
